// @ts-nocheck
// @NOTE has to be invoked with `new` to create `this` binding
// - https://stackoverflow.com/questions/1646698/what-is-the-new-keyword-in-javascript
// @NOTE should be converted to a `class` to work with `new` in TS
// - https://stackoverflow.com/questions/43623461/new-expression-whose-target-lacks-a-construct-signature-in-typescript
const SnapToRoute = function (map, marker, polylines, refreshMarkerWindows = () => { }, shouldSnapToPolylineStartEnd = false, shouldRefreshMarkerWindow = true) {
    this.routePixels_ = [];
    this.normalProj_ = map.getProjection();
    this.map_ = map;
    this.marker_ = marker;
    this.polylines_ = polylines;
    this.markerFinalLatLng = '';
    /*this.markerIndex = markerIndex;
    this.updateMarkerInfoWindow = updateMarkerInfoWindow;*/
    this.refreshMarkerWindows = refreshMarkerWindows;
    this.shouldSnapToPolylineStartEnd = shouldSnapToPolylineStartEnd;
    this.shouldRefreshMarkerWindow = shouldRefreshMarkerWindow;
    this.init_();
};
SnapToRoute.prototype.init_ = function () {
    this.loadLineData_();
    this.loadMapListener_();
};
SnapToRoute.prototype.updateTargets = function (marker, polylines) {
    this.marker_ = marker || this.marker_;
    this.polylines_ = polylines || this.polylines_;
    this.loadLineData_();
};
SnapToRoute.prototype.loadMapListener_ = function () {
    var me = this;
    me.updateMarkerLocation_(me.marker_.position);
    var distAlongRoute = me.getDistAlongRoute();
    if (Number.isNaN(distAlongRoute)) {
        distAlongRoute = 0;
    }
    if (typeof window.missionDistance !== 'undefined') {
        if (distAlongRoute / 1000 > window.missionDistance) {
            distAlongRoute = window.missionDistance * 1000;
        }
    }
    me.marker_.set('distance', distAlongRoute);
    me.marker_.set('calibrating', false);
    //me.updateMarkerInfoWindow(me.markerIndex, me.marker_);
    if (!this.shouldRefreshMarkerWindow) {
        me.refreshMarkerWindows(false, false);
    }
    else {
        me.refreshMarkerWindows(false);
    }
    google.maps.event.addListener(me.marker_, 'dragend', function (evt) {
        me.updateMarkerLocation_(evt.latLng);
        var distAlongRoute = me.getDistAlongRoute();
        if (Number.isNaN(distAlongRoute)) {
            distAlongRoute = 0;
        }
        if (typeof window.missionDistance !== 'undefined') {
            if (distAlongRoute / 1000 > window.missionDistance) {
                distAlongRoute = window.missionDistance * 1000;
            }
        }
        me.marker_.set('distance', distAlongRoute);
        me.marker_.set('calibrating', false);
        me.refreshMarkerWindows(true, true);
    });
    google.maps.event.addListener(me.marker_, 'dragstart', function (evt) {
        me.marker_.set('calibrating', true);
        me.refreshMarkerWindows(true, false);
    });
    // This event is start and continue drag i.e. continuous updates
    google.maps.event.addListener(me.marker_, 'drag', function (evt) {
        me.updateMarkerLocation_(evt.latLng);
    });
    google.maps.event.addListener(me.map_, 'zoomend', function (evt) {
        me.loadLineData_();
    });
};
SnapToRoute.prototype.getMarkerLocation = function () {
    return this.markerFinalLatLng;
};
SnapToRoute.prototype.loadLineData_ = function () {
    this.routePixels_ = [];
    this.polylines_.forEach((polyline) => {
        if (polyline.get('style') !== 'visible') {
            return;
        }
        const path = polyline.getPath();
        const pixelsArray = [];
        for (let i = 0; i < path.getLength(); i++) {
            const Px = this.normalProj_.fromLatLngToPoint(path.getAt(i));
            pixelsArray.push(Px);
        }
        this.routePixels_.push(pixelsArray);
    });
};
SnapToRoute.prototype.updateMarkerLocation_ = function (mouseLatLng) {
    var markerLatLng = this.getClosestLatLng(mouseLatLng);
    this.markerFinalLatLng = markerLatLng;
    this.marker_.setPosition(markerLatLng);
};
SnapToRoute.prototype.getClosestLatLng = function (latlng) {
    var r = this.distanceToLines_(latlng);
    return this.normalProj_.fromPointToLatLng(new google.maps.Point(r.x, r.y));
};
SnapToRoute.prototype.getDistAlongRoute = function (latlngOverride) {
    var latlng = latlngOverride ?? this.markerFinalLatLng;
    var line = this.distanceToLines_(latlng);
    return this.getDistToLine_(line);
};
SnapToRoute.prototype.distanceToLines_ = function (mouseLatLng) {
    var mousePx = this.normalProj_.fromLatLngToPoint(mouseLatLng);
    var routePixels_ = this.routePixels_;
    return this.getClosestPointOnLines_(mousePx, routePixels_);
};
SnapToRoute.prototype.getDistToLine_ = function (line) {
    let d = 0;
    let linesCount = 0;
    const lineIndex = line.i;
    this.polylines_.forEach((polyline) => {
        if (linesCount > lineIndex) {
            return;
        }
        let path = polyline.getPath().getArray();
        if (polyline.get('style') !== 'visible') {
            return;
        }
        for (let n = 0; n < path.length; n++) {
            linesCount += 1;
            if (linesCount > lineIndex) {
                return;
            }
            if (n === 0) {
                continue;
            }
            let pctTravelled = 1;
            if (linesCount === lineIndex) {
                pctTravelled = line.to;
            }
            let from;
            let to;
            from = path[n - 1];
            to = path[n];
            const distanceFromPoints = google.maps.geometry.spherical.computeDistanceBetween(from, to);
            const lineDistance = distanceFromPoints * pctTravelled;
            d += lineDistance;
        }
    });
    return d;
};
SnapToRoute.prototype.getClosestPointOnLines_ = function (pXy, aXysArray = []) {
    var minDist;
    var to;
    var from;
    var x;
    var y;
    var i;
    var dist;
    let currentIndex = 0;
    if (aXysArray.length === 0) {
        return {
            x,
            y,
            i,
            to,
            from,
        };
    }
    aXysArray.forEach((aXys) => {
        let foundAtIndex = 0;
        for (var n = 0; n < aXys.length; n++) {
            currentIndex += 1;
            if (n === 0) {
                continue;
            }
            if (aXys[n].x !== aXys[n - 1].x) {
                var a = (aXys[n].y - aXys[n - 1].y) / (aXys[n].x - aXys[n - 1].x);
                var b = aXys[n].y - a * aXys[n].x;
                dist = Math.abs(a * pXy.x + b - pXy.y) / Math.sqrt(a * a + 1);
            }
            else {
                dist = Math.abs(pXy.x - aXys[n].x);
            }
            var rl2 = Math.pow(aXys[n].y - aXys[n - 1].y, 2) + Math.pow(aXys[n].x - aXys[n - 1].x, 2);
            var ln2 = Math.pow(aXys[n].y - pXy.y, 2) + Math.pow(aXys[n].x - pXy.x, 2);
            var lnm12 = Math.pow(aXys[n - 1].y - pXy.y, 2) + Math.pow(aXys[n - 1].x - pXy.x, 2);
            var dist2 = Math.pow(dist, 2);
            var calcrl2 = ln2 - dist2 + lnm12 - dist2;
            if (calcrl2 > rl2) {
                dist = Math.sqrt(Math.min(ln2, lnm12));
            }
            if (minDist == null || minDist > dist) {
                to = Math.sqrt(lnm12 - dist2) / Math.sqrt(rl2);
                from = Math.sqrt(ln2 - dist2) / Math.sqrt(rl2);
                minDist = dist;
                i = currentIndex;
                foundAtIndex = n;
            }
        }
        if (isNaN(to)) {
            to = 0;
        }
        if (isNaN(from)) {
            to = 0;
        }
        if (to > 1) {
            to = 1;
        }
        if (from > 1) {
            to = 0;
            from = 1;
        }
        const prevAXys = aXys[foundAtIndex - 1];
        if (!prevAXys) {
            return;
        }
        var dx = prevAXys.x - aXys[foundAtIndex].x;
        var dy = prevAXys.y - aXys[foundAtIndex].y;
        x = aXys[foundAtIndex].x; // prevAXys.x - (dx * to);
        y = aXys[foundAtIndex].y; // prevAXys.y - (dy * to);
        if (this.shouldSnapToPolylineStartEnd) {
            x = aXys[foundAtIndex].x; // prevAXys.x - (dx * to);
            y = aXys[foundAtIndex].y; // prevAXys.y - (dy * to);
        }
        else {
            x = prevAXys.x - dx * to;
            y = prevAXys.y - dy * to;
        }
    });
    return {
        x: x,
        y: y,
        i: i,
        to: to,
        from: from,
    };
};
export default SnapToRoute;
